module.exports = __webpack_public_path__ + "img/bg_2.9ebf2ac8.png";